<template>
  <div class="businesses no-scrollbar">
    <ShopCreateNew />
    <WorkflowTypeStatsModal />

    <div style="padding-bottom: 7px; padding-left: 12px">
      <div class="has-text-left">
        <span class="button is-rounded" @click="openShopCreateNew">
          <i class="fa fa-plus" />
          &nbsp;Create </span
        >&nbsp;
        <span
          class="button has-text-grey is-rounded"
          style="padding: 8px"
          @click="openDebugConsole"
        >
          <i class="fa fa-laptop" /> </span
        >&nbsp;
        <span
          class="button is-rounded"
          style="padding: 14px"
          @click="showExtras = !showExtras"
        >
          <i class="fa fa-ellipsis-v" />
        </span>
        <toggle-button
          class="is-pulled-right"
          style="margin-right: 12px"
          :value="switchState"
          color="#35AC5E"
          :sync="true"
          :labels="{ checked: 'ON', unchecked: 'OFF' }"
          :height="36"
          :width="66"
          @change="switchChange($event.value)"
        />
      </div>
    </div>

    <div
      style="
        background-color: lightgrey;
        height: 2px;
        width: 100vw;
        margin-bottom: 10px;
      "
    />

    <div v-if="showExtras" class="notification">
      <a class="button btn" @click="createNewShop">
        <i class="fa fa-plus" />New Shop
      </a>
      <a class="button btn" @click="editLists">
        <i class="fa fa-list-ul" />List Editor
      </a>
      <a class="button btn" @click="toggleSpam">
        <i class="fa fa-bullhorn" />Blast Spam
      </a>
      <a class="button btn" @click="gotoTranslator">
        <i class="fa fa-language" />Translator
      </a>
      <a class="button btn" @click="linkShortener">
        <i class="fa fa-link" />Link Shortener
      </a>
      <a class="button btn" @click="killLongRunning">
        <i class="fa fa-bomb" />Kill Long Running
      </a>
      <a class="button btn" @click="gotoDelay('geometry')">
        <i class="fa fa-draw-polygon" />Draw Geometry
      </a>
      <a class="button btn" @click="goto('fleet_dispatcher')">
        <i class="fa fa-motorcycle" />Fleet Dispatcher
      </a>
      <a class="button btn">
        <i class="fa fa-file-invoice" />Driver Remit
        <span class="is-pulled-right">
          <span class="tag" @click="triggerDriverRemit(currentDate)">{{
            currentDate
          }}</span
          >&nbsp;
          <span class="tag" @click="triggerDriverRemit(yesterdayDate)">{{
            yesterdayDate
          }}</span>
        </span>
      </a>
      <a v-if="!showLocalStorage" class="button btn" @click="viewStorage">
        <i class="fa fa-database" />
        <!-- <span v-if="showLocalStorage">Hide Storage</span> -->
        <span>View Storage</span>
      </a>
      <!-- <a class="button ls" @click="viewStorage">View Storage</a>&nbsp;
      <a class="button ls" @click="clearStorage">Empty Storage</a> -->
    </div>

    <div v-else>
      <div v-if="!businessType" class="buttons" style="margin: 0 12px">
        <!-- residential -->
        <span :class="bizTypeBtn" @click="toggle">Apartment</span>
        <span :class="bizTypeBtn" @click="toggle">Condominium</span>
        <span :class="bizTypeBtn" @click="toggle">Hotel</span>
        <!-- transport -->
        <span :class="bizTypeBtn" @click="toggle">Sii Lor</span>
        <span :class="bizTypeBtn" @click="toggle">Songthaew</span>
        <span :class="bizTypeBtn" @click="toggle">Tuk Tuk</span>
        <span :class="bizTypeBtn" @click="toggle">Motocy</span>
        <span :class="bizTypeBtn" @click="toggle">Taxi</span>
        <!-- commerce -->
        <span :class="bizTypeBtn" @click="toggle">Bar</span>
        <span :class="bizTypeBtn" @click="toggle">Restaurant</span>
        <span :class="bizTypeBtn" @click="toggle">Shop</span>
        <!-- service -->
        <!-- <span class="tag is-info" @click="toggle">Travel Agency</span> -->
        <span :class="bizTypeBtn" @click="toggle">Service</span>
        <span :class="bizTypeBtn" @click="toggle">Other</span>
        <span :class="bizTypeBtn" @click="toggle">TUK</span>
      </div>

      <div v-else class="notification">
        <p
          class="has-text-left subtitle is-outlined"
          style="margin-bottom: 10px"
          @click="businessType = null"
        >
          <span class="has-text-grey">Business Type:</span>
          <span class="link" style="margin-left: 6px">{{ businessType }}</span
          >&nbsp;
          <button class="delete" />
        </p>

        <div v-if="loading">
          <i class="fa fa-cog fa-10x fa-spin" />
        </div>
        <div v-else>
          <div v-if="businesses.length" class="list">
            <div
              class="list-item has-text-left has-text-link"
              v-for="b in businesses"
              :key="b.id"
              @click="openBusinessProfile(b.id)"
            >
              <span class="single-line">{{ b.name }}</span
              >&nbsp;
              <!-- <span class="tag" :class="tagColor(b.business_type)">{{b.business_type}}</span> -->
            </div>
          </div>
          <div v-else class="subtitle notification is-black">
            No such businesses
          </div>
          <br />
        </div>
      </div>
    </div>

    <div v-if="showLocalStorage" class="local-storage no-scrollbar">
      <table class="table is-fullwidth">
        <thead>
          <tr @click="showLocalStorage = false">
            <th>
              Object
              <span
                class="is-pulled-right link has-text-primary"
                @click="clearStorage"
              >
                Clear
              </span>
            </th>
            <th @click="viewStorage">
              <span>{{ localStorageSize() }}</span>
              <i
                class="fa fa-times-circle is-pulled-right"
                style="padding: 4px 0"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="o in localStorageArray" :key="o[0]">
            <td @click="infoToast(o[0])">{{ shortenString(o[0], 20) }}</td>
            <td>{{ o[1] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <SuperSpamBlaster v-if="showSpamBlaster" @close="toggleSpam" />
  </div>
</template>

<script>
import EventBus from "../eventBus";
import ShopCreateNew from "@/components/ShopCreateNew.vue";
import WorkflowTypeStatsModal from "@/components/WorkflowTypeStatsModal.vue";
import SuperSpamBlaster from "@/components/SuperSpamBlaster.vue";

export default {
  name: "Businesses",
  components: {
    ShopCreateNew,
    WorkflowTypeStatsModal,
    SuperSpamBlaster,
  },
  data() {
    return {
      selected: null,
      switchState: false,
      showExtras: true,
      businessType: null,
      businesses: [],
      loading: false,
      localStorageArray: [],
      showLocalStorage: false,
      showSpamBlaster: false,
    };
  },
  computed: {
    bizTypeBtn() {
      return `button is-fullwidth biz-type-btn`;
    },
    currentDate() {
      var tz = { tz: "Asia/Bangkok" };
      return new Date().toLocaleString("sv-SE", tz).split(" ")[0];
    },
    yesterdayDate() {
      var yesterday = new Date(Date.now() - 86400000);
      var tz = { tz: "Asia/Bangkok" };
      return yesterday.toLocaleString("sv-SE", tz).split(" ")[0];
    },
  },
  deactivated() {
    this.showExtras = true;
  },
  activated() {
    // this.viewStorage();
  },
  methods: {
    createNewShop() {
      this.goto("/new_shop");
    },
    triggerDriverRemit(date) {
      // var date = this.currentDate; //"2022-08-06";
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em;margin-bottom:12px'>
        <i class='fa fa-file-invoice'></i>&nbsp;Trigger Driver Remit</p>
        <p><b>${date}</b></p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "1. Create",
        cancelButtonText: "2. Ready",
        cancelButtonColor: this.bulmaColor("success"),
      }).then((val) => {
        if (val.value) {
          this.infoToast("1. Create");
          this.createDriverRemit(date);
        } else if (val.dismiss === "cancel") {
          this.successToast("2. Ready");
          this.readyDriverRemit(date);
        }
      });
    },
    createDriverRemit(date) {
      var loader = this.loadingDots("blue");
      this.$store
        .dispatch("createDriverRemit", date)
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    readyDriverRemit(date) {
      var loader = this.loadingDots("green");
      this.$store
        .dispatch("readyDriverRemit", date)
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    toggleSpam() {
      this.showSpamBlaster = !this.showSpamBlaster;
    },
    sortAlphabet(arr, field) {
      return arr.sort((a, b) => {
        var textA = a[field].toUpperCase();
        var textB = b[field].toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
    },
    switchChange(state) {
      this.switchState = state;
      this.infoToast(`Toggle superuser role notifications to ${state}`);
    },
    getBusinessesByType(businessType) {
      this.loading = true;
      this.$store
        .dispatch("getBusinessesByType", businessType)
        .then((res) => (this.businesses = res.data))
        .catch((err) => this.apiError(err))
        .finally(() => (this.loading = false));
    },
    toggle(e) {
      this.businessType = e.target.innerText;
      this.getBusinessesByType(this.businessType);
    },
    openDebugConsole() {
      EventBus.$emit("OPEN_DEBUG");
    },
    showWorkflowTypeStats() {
      this.displayModal(".workflow-type-stats-modal");
      EventBus.$emit("WORKFLOW_TYPE_STATS");
    },
    openShopCreateNew() {
      if (this.loginOkay()) {
        this.displayModal(".shop-create-new-modal");
      }
    },
    openBusinessProfile(businessID) {
      this.console("openBusinessProfile", businessID);
      this.$store.commit("selectBusiness", businessID);
      this.$router.push(`/business_profile/${businessID}`);
    },
    gotoTranslator() {
      this.$router.push(`/translator`);
    },
    linkShortener() {
      this.$router.push(`/link_shortener`);
    },
    editLists() {
      this.$router.push(`/list_editor`);
    },
    viewStorage() {
      if (this.showLocalStorage) {
        this.showLocalStorage = false;
        return;
      }
      this.localStorageArray = this.localStorageSizeArray();
      this.showLocalStorage = true;
    },
    clearStorage() {
      // this.localStorageArray = this.localStorageSizeArray();
      // this.showLocalStorage = true;
      var size0 = this.localStorageSize(); // before
      this.$store.commit("clearBusinesses");
      this.$nextTick(() => {
        var size1 = this.localStorageSize(); // after
        this.infoToast(`Decreased localStorage<br>${size0} → ${size1}`, "top");
      });
      this.viewStorage();
    },
    tagColor(type) {
      var accommodations = ["Apartment", "Condominium", "Hotel"];
      if (accommodations.includes(type)) return "is-success";
      var transport = ["Songthaew", "Tuk Tuk", "Motocy", "Sii Lor", "Taxi"];
      if (transport.includes(type)) return "is-danger";
      var services = ["Bar", "Restaurant", "Shop"];
      if (services.includes(type)) return "is-info";
      if (type === "Other" || type === "Service") return "is-dark";
      if (type === "TUK") return "is-warning";
    },
    killLongRunning() {
      var loader = this.loadingDots();
      this.$store
        .dispatch("killLongRunningQueries")
        .then((res) => {
          console.log("killLongRunningQueries", res.data);
          this.successToast(res.data);
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.businesses {
  height: calc(100vh - 60px);
  width: 100vw;
  overflow-x: hidden;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
  /* display: inline-block; */
}
.notification {
  padding: 0 10px;
}
.notification a {
  margin-bottom: 10px;
}
.fa-cog {
  position: absolute;
  margin-top: 10px;
  left: calc(50vw - 80px);
}
.tag.is-large {
  font-weight: 500;
}
.notification.is-black {
  padding: 10px;
}
.notification .btn {
  width: 100%;
  text-align: left;
  display: table;
  font-weight: 500;
}
.btn .fa {
  margin-right: 6px;
  width: 30px;
}
.ls {
  width: calc(50vw - 15px);
  border-radius: 25px;
}
.local-storage {
  position: absolute;
  left: 0;
  bottom: 0;
  height: calc(100vh - 355px);
  overflow-x: auto;
  width: 100vw;
  box-shadow: 0 0 8px black;
}
.biz-type-btn {
  width: 100%;
  text-align: left;
  display: table;
  font-weight: 500;
}
.btn .tag {
  border: 1px solid var(--info);
}
</style>